var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resolvedSrc)?_c('img',{style:({ width: (_vm.size + "px") }),attrs:{"src":_vm.resolvedSrc,"alt":_vm.alt}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }